import { useState, useEffect } from "react";
import { FormikErrors, FormikTouched, useFormik } from "formik";
import { useDispatch } from "react-redux";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import Select from "react-select";
import * as yup from "yup";
import "./style.css";

import {
  setLineIPsDemo,
  restartLineIPsDemo,
  getLineItemInfoDemo,
  resetLineItemDemoAction,
} from "../../Redux/Actions/CLineItemDemoActions";
import { convertUtcToLocal } from "../../utils/functions";
import moment from "moment";
import Spinner from "../../Components/UI/Spinner/Spinner";
import FeatherIcon from "feather-icons-react";

const FilteringForm = (props: any) => {
  const [restartFilterLoader, setRestartFilterLoader] = useState(false);
  const [startTimeAfterSave, setStartTimeAfterSave] = useState("");
  const [endTimeAfterSave, setEndTimeAfterSave] = useState("");
  const [rows, setRows] = useState([{ ipAddress: "", comment: "" }]);
  const [timeRemained, setTimeRemained] = useState("");
  const {
    autoClearOptions,
    customStyles,
    IPfilteringDemoState,
    adsTypeDefaultSelection,
    ads_shown_list,
  } = props;
  const dispatch = useDispatch();

  const handleSubmitSuccess = (data: any) => {
    if (data.endTime === "") {
      setTimeRemained("");
    }
    setRestartFilterLoader(false);
    setStartTimeAfterSave(data.startTime);
    setEndTimeAfterSave(data.endTime);
  };

  const addRow = () => {
    setRows([...rows, { ipAddress: "", comment: "" }]);
  };

  const handleRemove = (index:number)=>{
    if (window.confirm(`Are you sure you want to delete this record?`)) {
      rows.splice(index,1);
      setRows([...rows]);
      formik.handleSubmit();
      // hanldeRefreshFilter();
    }
}
  

  useEffect(() => {
    setRows(IPfilteringDemoState.rows.length>0?IPfilteringDemoState.rows:[{ ipAddress: "", comment: ""}]);
  }, [IPfilteringDemoState]);

  const formik = useFormik({
    initialValues: {
      line_item_name: IPfilteringDemoState.line_item_name,
      line_item_id: IPfilteringDemoState.line_item_id,
      rows: IPfilteringDemoState.rows,
      dur: IPfilteringDemoState.dur,
      imps: IPfilteringDemoState.imps,
      unit: IPfilteringDemoState.unit,
      lbl:
        IPfilteringDemoState.imps === ""
          ? "No frequency capping is set"
          : IPfilteringDemoState.imps +
            " ads every " +
            IPfilteringDemoState.dur +
            " " +
            IPfilteringDemoState.unit,
      autoClear: IPfilteringDemoState.timer,
      ads_shown: IPfilteringDemoState?.adsType
        ? IPfilteringDemoState?.adsType
        : adsTypeDefaultSelection,
      bids: IPfilteringDemoState.bids,
    },
    // validationSchema: yup.object().shape({
    //   ipAddresses: yup
    //       .array()
    //       /*.required()*/
    //       .transform((value, originalValue, context) => {
    //           if (context.isType(value) && value !== null) return value;
    //           return originalValue ? [...originalValue.split("\n")] : [];
    //       })
    //       .of(yup.string().trim().matches(
    //           /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/i,
    //           "Please use IPv4 address format (X.X.X.X)"
    //       ))
    // }),
    validationSchema: yup.object().shape({
      rows: yup.array().of(
        yup.object().shape({
          ipAddress: yup
            .string()
            .trim()
            .matches(
              /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/i,
              "Please use IPv4 address format (X.X.X.X)"
            ),
          //comment: yup.string(),
        })
      ),
    }),
    onSubmit: (values) => {
      const hasInvalidFields = values.rows.some(
        (row: { ipAddress: any }, index: any) =>
          (Array.isArray(formik.errors.rows) &&
            Array.isArray(formik.touched.rows) &&
            !!(formik.errors.rows[index] as FormikErrors<any>)?.ipAddress &&
            !!(formik.touched.rows[index] as FormikTouched<any>)?.ipAddress)
      );
      setStartTimeAfterSave("");
      if (hasInvalidFields) {
        console.error("Please correct the invalid fields before submitting.");
        return;
      }
      
      const filteredRows = rows.filter(row => row.ipAddress && row.ipAddress !== '');
      values.rows = filteredRows;

      dispatch(
        setLineIPsDemo(
          //ipAddresses,
          //comments,
          values.rows,
          values.autoClear,
          handleSubmitSuccess,
          values.ads_shown
        )
      );
    },
  });

  const changeAutoClear = (p: any) => {
    formik.setFieldValue("autoClear", p.value);
    IPfilteringDemoState.timer = p.value;
  };

  useEffect(() => {
    let timeElapsed = setInterval(() => {
      if (
        !restartFilterLoader &&
        (IPfilteringDemoState.endTime || endTimeAfterSave)
      ) {
        let endDt = moment(
          endTimeAfterSave ? endTimeAfterSave : IPfilteringDemoState.endTime
        );
        let secs = endDt.diff(moment(), "seconds");
        if (secs > 0) {
          setTimeRemained(moment.utc(secs * 1000).format("HH:mm:ss"));
        } else {
          setTimeRemained("");
        }
      } else {
        setTimeRemained("");
      }
    }, 1000);

    return () => {
      clearInterval(timeElapsed);
    };
  }, [IPfilteringDemoState.endTime, endTimeAfterSave, restartFilterLoader]);

  const hanldeRefreshFilter = async () => {
    setStartTimeAfterSave("");
    setEndTimeAfterSave("");
    setTimeRemained("");
    setRestartFilterLoader(true);
    await dispatch(
      restartLineIPsDemo(handleSubmitSuccess, formik.values?.ads_shown)
    );
    setRestartFilterLoader(false);
  };

  const handleAdsTypeChange = async (adsType: any) => {
    if (adsType !== "Select Type") {
      setStartTimeAfterSave("");
      setEndTimeAfterSave("");
      setTimeRemained("");
      await dispatch(getLineItemInfoDemo(adsType));
    } else {
      await dispatch(resetLineItemDemoAction());
    }
  };

  return (
    <>
      {restartFilterLoader && (
        <div className="popUpUser">
          <Spinner className="m-2" color={"primary"}></Spinner>
        </div>
      )}
      <Card style={{ marginBottom: "24px" }}>
        <Card.Body style={{ padding: "2rem" }}>
          <Row>
            <Col md={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                style={{ display: "flex", alignItems: "center" }}
              >
                <Form.Label column lg={3} id="smallerFontSize">
                  Ads ID
                </Form.Label>
                <Col lg={9}>
                  <Form.Control
                    name="line_item_id"
                    value={formik.values.line_item_id}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className="fsz-875rem"
                    id="special-disabled-grey"
                    disabled={true}
                  />
                </Col>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                style={{ display: "flex", alignItems: "center" }}
              >
                <Form.Label column lg={3} id="smallerFontSize">
                  Ads Name
                </Form.Label>
                <Col lg={9}>
                  <Form.Control
                    name="line_item_name"
                    value={formik.values.line_item_name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className="fsz-875rem"
                    id="special-disabled-grey"
                    disabled={true}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                style={{ display: "flex", alignItems: "center" }}
              >
                <Form.Label column lg={3} id="smallerFontSize">
                  Ads Shown:
                </Form.Label>
                <Col lg={9} style={{ flexGrow: 1 }}>
                  <Select
                    styles={customStyles}
                    value={ads_shown_list.find(
                      (item: any) => item.value === formik.values.ads_shown
                    )}
                    options={ads_shown_list}
                    onChange={(selectedOption: any) => {
                      handleAdsTypeChange(selectedOption.value);
                      formik.setFieldValue("ads_shown", selectedOption.value);
                    }}
                    className="fsz-875rem"
                    onBlur={formik.handleBlur}
                    isDisabled={ads_shown_list.length <= 1}
                  />
                </Col>
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                style={{ display: "flex", alignItems: "center" }}
              >
                <Form.Label
                  column
                  lg={9}
                  id="smallerFontSize"
                  style={{ fontWeight: "200" }}
                >
                  {formik.values.lbl !== "No frequency capping is set"
                    ? `Show ${formik.values.lbl} ${
                        formik.values.ads_shown === "with"
                          ? "per user"
                          : "per IP"
                      }`
                    : `${formik.values.lbl}`}
                </Form.Label>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                style={{ display: "flex", alignItems: "center" }}
              >
                <Form.Label column lg={3} id="smallerFontSize">
                  Auto Clear Filters
                </Form.Label>
                <Col lg={9} style={{ flexGrow: 1 }}>
                  <Select
                    styles={customStyles}
                    value={autoClearOptions.find(
                      (options: any) => options.value === IPfilteringDemoState.timer
                    )}
                    options={autoClearOptions}
                    onChange={changeAutoClear}
                    className="fsz-875rem"
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
        </Card.Body>
      </Card>
      <Card style={{ marginBottom: "24px" }}>
        <Card.Body>
          <Row>
            <Col>
              <h3
                style={{
                  color: "#343a40",
                  textAlign: "left",
                  fontSize: "15px",
                  fontWeight: "600",
                }}
              >
                TARGETING
              </h3>
            </Col>
            <Col lg={3}>
              <Form.Group className="mb-3" as={Row}>
                <Form.Label column lg={4} id="smallerFontSize">
                  Start Time
                </Form.Label>
                <Col lg={3}>
                  <Form.Label
                    column
                    id="smallerFontSize"
                    style={{ fontWeight: "200" }}
                  >
                    {/* {startTimeAfterSave?new Date(startTimeAfterSave).toTimeString():IPfilteringState.startTime? new Date(IPfilteringState.startTime).toTimeString():''} */}
                    {startTimeAfterSave
                      ? convertUtcToLocal(startTimeAfterSave, "HH:mm")
                      : IPfilteringDemoState.startTime
                      ? convertUtcToLocal(IPfilteringDemoState.startTime, "HH:mm")
                      : "--:--"}
                  </Form.Label>
                </Col>
              </Form.Group>
            </Col>
            <Col lg={3}>
              <Form.Group className="mb-3" as={Row}>
                <Form.Label column lg={6} id="smallerFontSize">
                  Time remaining
                </Form.Label>
                <Col lg={3}>
                  <Form.Label
                    column
                    id="smallerFontSize"
                    style={{ fontWeight: "200" }}
                  >
                    {timeRemained ? timeRemained : "--:--:--"}
                  </Form.Label>
                </Col>
              </Form.Group>
            </Col>
            <Col lg={2} className="mt-1">
              <span
                onClick={timeRemained ? hanldeRefreshFilter : () => {}}
                style={{
                  color: "#59d3e9",
                  cursor: timeRemained ? "pointer" : "not-allowed",
                  //display: "flex",
                  alignItems: "center",
                }}
              >
                Restart Filter{" "}
                <FeatherIcon
                  column
                  md={1}
                  icon="refresh-cw"
                  className="icon-dual icon-xs"
                  style={{
                    color: "#59d3e9",
                    cursor: timeRemained ? "pointer" : "not-allowed",
                  }}
                />
              </span>
            </Col>
          </Row>
          {rows.map((row, index: number) => (
            <Row key={index}>
              <Col>
                <Form.Group as={Row} className="mb-3">
                  <Form.Label column lg={3} id="smallerFontSize">
                    IP Address
                  </Form.Label>
                  <Col lg={8}>
                    <Form.Control
                      name={`rows[${index}].ipAddress`}
                      value={row.ipAddress}
                      onChange={(e) => {
                        const newRows = [...rows];
                        newRows[index].ipAddress = e.target.value;
                        setRows(newRows);
                        formik.handleChange(e);
                      }}
                      onBlur={formik.handleBlur}
                      className="fsz-875rem"
                      isInvalid={
                        (!row.ipAddress && rows.length > 1) ||
                        (Array.isArray(formik.errors.rows) &&
                          Array.isArray(formik.touched.rows) &&
                          !!(formik.errors.rows[index] as FormikErrors<any>)
                            ?.ipAddress &&
                          !!(formik.touched.rows[index] as FormikTouched<any>)
                            ?.ipAddress)
                      }
                    />
                    {Array.isArray(formik.errors.rows) &&
                      Array.isArray(formik.touched.rows) &&
                      !!(formik.errors.rows[index] as FormikErrors<any>)
                        ?.ipAddress &&
                      !!(formik.touched.rows[index] as FormikTouched<any>)
                        ?.ipAddress && (
                        <Form.Control.Feedback type="invalid">
                          {"Please use IPv4 address format (X.X.X.X)"}
                        </Form.Control.Feedback>
                      )}
                    {!row.ipAddress && rows.length > 1 && (
                      <Form.Control.Feedback type="invalid">
                        {"IP address cannot be empty"}
                      </Form.Control.Feedback>
                    )}
                  </Col>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group as={Row} className="mb-3">
                  <Form.Label column lg={3} id="smallerFontSize">
                    Comment
                  </Form.Label>
                  <Col lg={8}>
                    <Form.Control
                      name={`rows[${index}].comment`}
                      value={row.comment}
                      onChange={(e) => {
                        const newRows = [...rows];
                        newRows[index].comment = e.target.value;
                        setRows(newRows);
                        formik.handleChange(e);
                      }}
                      onBlur={formik.handleBlur}
                      className="fsz-875rem"
                      // as="textarea"
                      id="example-textarea"
                      //isInvalid={!!formik.errors.comments}
                    />
                    {/* <Form.Control.Feedback type="invalid">{formik.errors?.comments ? 'Please use IPv4 address format (X.X.X.X)':'' } </Form.Control.Feedback>  */}
                  </Col>
                  <Col className="text-end">
                    <span title="trash" onClick={()=>handleRemove(index)}>
                      <FeatherIcon icon="trash-2" className="icon-dual" />
                    </span>
                  </Col>
                </Form.Group>
              </Col>
            </Row>
          ))}
          <Col className="text-end">
            <Button
              variant="light"
              style={{ color: "#596ef8", backgroundColor: "#e8eaff" }}
              onClick={addRow}
            >
              Add Row
            </Button>
          </Col>
        </Card.Body>
      </Card>
      <Card>
        <Card.Body style={{ display: "flex", alignItems: "center" }}>
          <Button
            onClick={() => {
              formik.handleSubmit();
            }}
            style={{ margin: "0" }}
            variant="primary"
          >
            Save Changes
          </Button>
        </Card.Body>
      </Card>
    </>
  );
};
export default FilteringForm;